import { useTeam } from "../../../context/TeamContext";
import { useToast } from "../../../components/toast";
import { useState } from "react";
import { BoatsAPI } from "../../../APIs/boats.api";
import { CreateBoatDTO } from "../../../types/boat.types";
import BoatForm from "./boat-form";
import { useNavigate } from "react-router-dom";

export interface IBoatAddProps {
  onCancel: () => void;
}

export default function BoatAdd({ onCancel }: IBoatAddProps) {
  const { getTeam } = useTeam();
  const { addToast } = useToast();
  const [formData, setFormData] = useState<CreateBoatDTO>({
    name: "",
    registration_number: "",
    engine_brand: "",
    hp: 0,
    has_radio: false,
    is_yacht: false,
  });
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleChange = (e: React.ChangeEvent<HTMLElement>) => {
    const { name, value, type, checked } = e.target as HTMLInputElement;

    setFormData((prev) => {
      if (!prev) return prev;

      return {
        ...prev,
        [name]: type === "checkbox" ? checked : value,
      };
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const response = await BoatsAPI.postBoat(formData);
      if (response.statusCode === 201) {
        addToast({
          message: "¡Embarcación creada!",
          type: "success",
          location: "bottom-center",
        });
        getTeam();
        navigate("/dashboard", { replace: true });
      } else {
        addToast({
          message: response.message,
          type: "error",
          location: "bottom-center",
          duration: 10000,
        });
      }
    } catch (error) {
      addToast({
        message: "Error al crear la embarcación, intente nuevamente",
        type: "error",
        location: "bottom-center",
        duration: 10000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <BoatForm
      buttonText={"Crear"}
      createBoat={formData}
      handleChange={handleChange}
      onSubmit={handleSubmit}
      onCancel={onCancel}
      isSubmitting={isSubmitting}
    />
  );
}
